export const CoreValuesService = {
    appVersion: '0.8.7',
}